import { useEffect, useState, useRef, useCallback } from "react";
import Camera from "../../assets/img/Camera.svg";
import axios from "axios";
import BottomSheet from "../../components/BottomSheet";
import Modal from "../../components/Modal";
import CallSelect from "../../components/CallSelect";
import CircleX from "../../assets/img/circle-x.svg";
import ApiUrl from "../../config/app-config";
import { onlyRequest, WKWebViewJSBridge } from "../../jsbridge";
import { usePermissionStore } from "../../store/permission";
import { getDeviceType } from "src/utils/deviceType";

const jsbridge = WKWebViewJSBridge();
const baseURL = ApiUrl();

const QnaWrite = (props) => {
  const pageName = "문의하기";
  const headerUi = {
    goback: false,
    closeAll: true,
    Navi: null,
  };

  const isCameraAllowed = usePermissionStore((state) => state.isCameraAllowed);

  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);

  //userId
  const users = sessionStorage.getItem("userId");
  const userId = Number(users);
  const appVersion = sessionStorage.getItem("appVer");

  /**userData GET */
  const [userData, setUserData] = useState();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/user`, {
        params: {
          userId: userId,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      setUserData(result);
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
  }, []);

  /**ios aos 분기 */
  const [phoneType, setPhoneType] = useState();
  function checkMobile() {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      //안드로이드
      setPhoneType("a");
      return "android";
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      //IOS
      setPhoneType("i");
      return "ios";
    } else {
      //아이폰, 안드로이드 외
      setPhoneType("a");
      return "other";
    }
  }
  useEffect(() => {
    checkMobile();
  }, []);

  /**TextArea 글자 수 체크 */
  const [textArea, setTextArea] = useState("");
  const onTextHandler = (e) => {
    setTextArea(e.target.value);
  };

  /*Select 선택값 받아오기 */
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openBottom, setOpenBottom] = useState(false);
  const [selected, setSelected] = useState();
  const selectHandler = (select) => {
    setSelected(select === undefined ? selected : select);
  };

  /**이미지 업로더 */
  const imageInput = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  // 사진 첨부 버튼 클릭시 실행
  const onClickImageUpload = () => {
    const deviceType = getDeviceType();

    // ios의 경우 네이티브 권한 설정 필요 (최초 한번)
    const isIos = deviceType === "ios";
    const isFirstRequestCameraAllowed = isCameraAllowed !== "true";
    if (isIos && isFirstRequestCameraAllowed) {
      onlyRequest("requestCameraAuth");
      return;
    }

    imageInput.current?.click();
  };

  // 앱에서 권한 허용시 한번만 실행
  useEffect(() => {
    const isAutoClicked = sessionStorage.getItem("isAutoClicked");

    if (isCameraAllowed === "true" && isAutoClicked !== "true") {
      imageInput.current?.click();
      sessionStorage.setItem("isAutoClicked", "true");
    }
  }, [isCameraAllowed]);

  const getUploadUrl = useCallback(async (extension) => {
    try {
      const response = await axios.post(`${baseURL}/image/url`, {
        extensionName: extension,
      });
      return response.data; // 응답 데이터 객체 전체 반환
    } catch (error) {
      console.error("URL 요청 에러:", error);
      return null;
    }
  }, []);

  const uploadImage = useCallback(
    async (file) => {
      const extension = file.type.split("/")[1];
      const uploadData = await getUploadUrl(extension);
      if (uploadData) {
        try {
          await axios.put(uploadData.url, file, {
            headers: {
              "Content-Type": file.type,
            },
          });

          const { path } = uploadData;
          const objectUrl = URL.createObjectURL(file);

          setSelectedFiles((prev) => [...prev, { path, objectUrl }]);
        } catch (error) {
          console.error("파일 업로드 에러:", error);
          props.onError(true);
        }
      }
    },
    [getUploadUrl]
  );

  const onChangeImage = useCallback(
    async (e) => {
      props.onIsLoading(true); // 로딩 시작
      const files = Array.from(e.target.files);

      if (selectedFiles.length + files.length <= 15) {
        const uploadPromises = files.map((file) => uploadImage(file)); // 개별 파일 업로드
        await Promise.all(uploadPromises); // 모든 파일 업로드 완료 대기
      } else {
        alert("사진 첨부는 최대 15장 까지만 가능합니다.");
      }

      props.onIsLoading(false); // 로딩 종료
    },
    [uploadImage]
  );

  /**운행번호 선택 */
  const [callSelect, setCallSelect] = useState("");
  const onCallSelect = (call) => {
    setCallSelect(call);
  };
  useEffect(() => {
    if (
      selected !== null &&
      selected !== undefined &&
      selected !== "정산문의" &&
      selected &&
      selected.trim().length !== 0
    ) {
      setCallSelect("false");
    } else if (selected === "정산문의" && callSelect === "false") {
      setCallSelect("");
    }
  }, [selected, callSelect]);

  const onCallNum = () => {
    setIsModalOpen(true);
  };

  /**이미지 삭제 */
  const onDeleteImage = useCallback(async (path) => {
    try {
      await axios.delete(`${baseURL}/image`, {
        data: { path },
      });
      setSelectedFiles((prev) => prev.filter((file) => file.path !== path));
    } catch (error) {
      console.error("이미지 삭제 에러:", error);
    }
  }, []);

  const offset = 1000 * 60 * 60 * 9;
  const koreaNow = new Date(new Date().getTime() + offset);

  //2022-07-19 06:31:12  -> UTC
  // console.log(koreaNow.toISOString())
  //2022-07-19 15:31:12  -> Seoul/Asian

  /**보내기 성공 */
  const [successModal, setSuccessModal] = useState(false);
  const onSubmit = async () => {
    props.onIsLoading(true);

    const imageUrlList =
      selectedFiles.length > 0 ? selectedFiles.map((file) => file.path) : [];

    await axios({
      url: `${baseURL}/qna`,
      method: "post",
      data: {
        userId: userId,
        email: userData.email ? String(userData.email) : null,
        phone: userData.phone ? String(userData.phone) : null,
        deviceType: phoneType,
        appVersion: appVersion,
        category: selected,
        question: textArea,
        randomCode: callSelect !== "false" ? callSelect : null,
        imageUrlList: imageUrlList,
      },
    })
      .then(() => {
        props.onIsLoading(false);
        setSuccessModal(true);
      })
      .catch((error) => {
        console.error(error);
        props.onIsLoading(false);
        props.onError(true);
      });
  };

  //바텀시트, 성공 모달 있을 시 스크롤 고정
  useEffect(() => {
    if (successModal === true || isModalOpen === true || openBottom === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [successModal, isModalOpen, openBottom]);

  return (
    <>
      <div className="container qna_write_wrap">
        <form action="#">
          <span>문의 유형</span>
          <input
            readOnly
            type="text"
            value={
              selected !== undefined && selected !== null
                ? selected
                : "문의 유형"
            }
            onClick={() => setOpenBottom(true)}
            className={
              selected !== undefined && selected !== null
                ? "select selected"
                : "select select_none"
            }
          />
          <textarea
            name="qna_txt"
            id="qna_txt"
            cols="30"
            rows="10"
            placeholder="문의 내용을 작성해 주세요."
            value={textArea}
            maxLength={1000}
            onChange={onTextHandler}
          ></textarea>
          <span className="text_length">({textArea.length}/1000)</span>
          {selected && selected === "정산문의" ? (
            <div className="drive_num">
              <span>운행 번호</span>

              <input
                placeholder="운행 번호를 선택해 주세요."
                type="text"
                readOnly
                value={callSelect || ""}
                onClick={onCallNum}
              />
            </div>
          ) : null}
          <span>
            사진 첨부 ( {selectedFiles && selectedFiles.length} / 15 )
          </span>
          <div className="photoBox add_photo">
            <input
              type="file"
              ref={imageInput}
              accept="image/jpg, image/jpeg, image/png"
              style={{ display: "none" }}
              onChange={onChangeImage}
            />
            <button
              type="button"
              onClick={onClickImageUpload}
              className="upload_file"
            >
              <img src={Camera} alt="사진업로드" />{" "}
            </button>
            {selectedFiles.map((imgData, index) => (
              <div className="img_wrap" key={index}>
                <img
                  className="upload_img"
                  src={imgData.objectUrl}
                  alt="첨부사진"
                />
                <button
                  onClick={() => onDeleteImage(imgData.path)}
                  type="button"
                >
                  {" "}
                  {/* path 전달 */}
                  <img src={CircleX} alt="삭제" />
                </button>
              </div>
            ))}
          </div>
        </form>
      </div>
      {openBottom && (
        <div className="bottom_sheet">
          <BottomSheet
            title={"유형 선택"}
            onSelect={selectHandler}
            closeModal={() => setOpenBottom(false)}
          />
        </div>
      )}
      {selected !== undefined &&
      selected !== null &&
      textArea !== undefined &&
      textArea !== null &&
      textArea.trim().length !== 0 &&
      callSelect.trim().length !== 0 ? (
        <button className="submit_btn" type="submit" onClick={onSubmit}>
          문의하기
        </button>
      ) : (
        <button className="submit_btn submit_btn_disabled" disabled>
          문의하기
        </button>
      )}
      {isModalOpen && (
        <CallSelect
          userId={userId}
          closeModal={() => setIsModalOpen(false)}
          onCallSelect={onCallSelect}
        />
      )}
      {successModal && (
        <Modal closeModal={() => setSuccessModal(false)} navi={true}>
          <h5 className="success_title">접수가 완료되었습니다.</h5>
          <p className="success_content">
            문의하신 내용이 정상 제출 되었습니다. 빠른 시일 내에 답변
            드리겠습니다.
          </p>
        </Modal>
      )}
    </>
  );
};
export default QnaWrite;
